import {Input} from '@main/components/form/form-field/input';
import {replaceBadInNumber} from '@main/utils/number-format';

/** Класс для поля ввода числа. */
export class NumberInput extends Input {
  /**
   * Конструктор класса.
   *
   * @param {object} props Параметры компонента.
   * @param {array} props.productsIds Список ИД товаров в списке.
   * @param {string} props.type Тип кнопки.
   */
  constructor(props) {
    super(props);
  }

  /**
   * Прослушиваем события в инпуте с телефоном.
   *
   * @returns {void}
   */
  bindEventListeners() {
    super.bindEventListeners();
    this.el.addEventListener('paste', this.onPaste.bind(this));
  }

  /**
   * Применение маски к числу при вводе.
   *
   * @param {Event} e Событие, происходящее при вводе в инпуте.
   * @returns {void}
   */
  onInput(e) {
    super.onInput();
    const input = e.target;
    this.replaceBadCharacters(input);
  }

  /**
   * Удалить все, что не число и не точка, запятую заменить на точку.
   *
   * @param {HTMLInputElement} input Поле ввода.
   * @returns {void}
   */
  replaceBadCharacters(input) {
    input.value = replaceBadInNumber(input.value);
  }

  /**
   * Применение маски к числу при вставке скопированного номера.
   *
   * @param {Event} e Событие, происходящее при вставке скопированного номера.
   * @returns {void}
   */
  onPaste(e) {
    const input = e.target;
    this.replaceBadCharacters(input);
  }
}
